module.exports = __webpack_public_path__ + "img/place_centre.bab6f120.webp";